// New Relic must be imported first for proper instrumentation
import './newrelic'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import Modal from 'react-modal'
import { initSentry } from './utils/sentry'
import { initMixpanel } from './utils/analytics/initMixpanel'
import './index.css'  // Tailwind v4 imports and CSS-based styles
import './index.scss' // Sass-specific styles with SCSS variables
import App from './App'

// Handle chunk load errors (stale cache after deployment)
// This catches errors when old HTML references JS chunks that no longer exist
window.addEventListener('error', (event) => {
  const isChunkLoadError =
    event.message?.includes('Loading chunk') ||
    event.message?.includes('Loading CSS chunk') ||
    event.message?.includes('Failed to fetch dynamically imported module') ||
    event.message?.includes("is not a valid JavaScript MIME type")

  if (isChunkLoadError) {
    // Prevent infinite reload loops - only reload once per session
    const reloadKey = 'chunk_error_reload'
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, 'true')
      window.location.reload()
    }
  }
})

// Initialize Sentry before rendering the app
initSentry()

// Initialize Mixpanel for analytics
initMixpanel()

const rootElement = document.getElementById('root')
if (rootElement) {
  // Set the app element for react-modal accessibility
  Modal.setAppElement('#root')
  
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
} else {
  console.error('Could not find root element')
}
